<!--eslint-disable max-len-->
<template>
  <div>
    <link
      href="https://cdn.jsdelivr.net/npm/bootstrap@5.0.0-beta1/dist/css/bootstrap.min.css"
      rel="stylesheet"
      integrity="sha384-giJF6kkoqNQ00vy+HMDP7azOuL0xtbfIcaT9wjKHr8RbDVddVHyTfAAsrekwKmP1"
      crossorigin="anonymous"
    />
    <PublicReply />
  </div>
</template>

<script>
import PublicReply from "./components/PublicReply.vue";
import store from "@/store/store.js";

export default {
  name: "App",
  data() {
    return {
      langs: ["de", "en", "fr", "it"],
    };
  },
  components: {
    PublicReply,
  },
  methods: {
    localStorage() {
      const test = "test";
      if (typeof localStorage !== "undefined") {
        try {
          localStorage.setItem(test, test);
          localStorage.removeItem(test);
          return true;
        } catch (e) {
          return false;
        }
      }
    },
  },
  created: function () {
    if (this.$route.query.lang && this.langs.includes(this.$route.query.lang)) {
      this.$i18n.locale = this.$route.query.lang;
    }
    store.setLocalStorage(this.localStorage());
  },
};
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
.center {
  margin: auto;
  text-align: center;
}
</style>
